import {Injectable} from '@nestjs/common';
import { UnitCodes } from '../unit-codes.entity';
import { UnitCodeDTO } from './unit-codes.dto';

@Injectable()
export class UnitcodeAdapter {
    /**
     * 
     * @param DestinationDTO 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( unitcodesDTO: UnitCodeDTO, isUpdate: boolean = false): UnitCodes {
        const unitcodes = new UnitCodes();
        if(isUpdate){
            unitcodes.unitcodeId=unitcodesDTO.unitcodeId;
          }    
        // unitcodes.unitcodesId=unitcodesDTO.unitcodesId;
        unitcodes.unitcodeName=unitcodesDTO.unitcodeName;
        unitcodes.plantType=unitcodesDTO.plantType;
        unitcodes.villageName=unitcodesDTO.villageName;
        unitcodes.mandalName=unitcodesDTO.mandalName;
        unitcodes.distirctName=unitcodesDTO.distirctName;
        unitcodes.stateName=unitcodesDTO.stateName;
        unitcodes.countryName=unitcodesDTO.countryName;
        unitcodes.fdaRegNumber=unitcodesDTO.fdaRegNumber;
        unitcodes.feiNumber=unitcodesDTO.feiNumber;
        unitcodes.shortKey=unitcodesDTO.shortKey;
        unitcodes.postalCode=unitcodesDTO.postalCode;
        unitcodes.plantCode=unitcodesDTO.plantCode;
        unitcodes.bapNo=unitcodesDTO.bapNo;
        unitcodes.approvalNo=unitcodesDTO.approvalNo;
        unitcodes.ascNo=unitcodesDTO.ascNo;
        unitcodes.walmartId=unitcodesDTO.walmartId;
        unitcodes.fishInapprovalNo=unitcodesDTO.fishInapprovalNo;
        unitcodes.krogerNo=unitcodesDTO.krogerNo;
        unitcodes.company = unitcodesDTO.company
        unitcodes.companyId = unitcodesDTO.companyId

        unitcodes.isActive=unitcodesDTO.isActive==undefined?true:unitcodesDTO.isActive;
        if (isUpdate){
            unitcodes.updatedUser = unitcodesDTO.updatedUser;
        }else {
            unitcodes.isActive = true;
            unitcodes.createdUser=unitcodesDTO.createdUser;
        }
        return unitcodes;
    }
    public convertEntityToDto( unitcodesData: UnitCodes): UnitCodeDTO{
        const unitcodes = new UnitCodes();
        unitcodes.unitcodeId=unitcodesData.unitcodeId;
        unitcodes.unitcodeName=unitcodesData.unitcodeName;
        unitcodes.plantType=unitcodesData.plantType;
        unitcodes.villageName=unitcodesData.villageName;
        unitcodes.mandalName=unitcodesData.mandalName;
        unitcodes.distirctName=unitcodesData.distirctName;
        unitcodes.stateName=unitcodesData.stateName;
        unitcodes.countryName=unitcodesData.countryName;
        unitcodes.fdaRegNumber=unitcodesData.fdaRegNumber;
        unitcodes.feiNumber=unitcodesData.feiNumber;
        unitcodes.bapNo=unitcodesData.bapNo;
        unitcodes.approvalNo=unitcodesData.approvalNo;
        unitcodes.ascNo=unitcodesData.ascNo;
        unitcodes.walmartId=unitcodesData.walmartId;
        unitcodes.fishInapprovalNo=unitcodesData.fishInapprovalNo;
        unitcodes.krogerNo=unitcodesData.krogerNo;
        unitcodes.shortKey=unitcodesData.shortKey;
        unitcodes.postalCode=unitcodesData.postalCode;
        unitcodes.plantCode=unitcodesData.plantCode;
        unitcodes.isActive=unitcodesData.isActive;
        unitcodes.createdAt=unitcodesData.createdAt;
        unitcodes.createdUser=unitcodesData.createdUser;
        unitcodes.updatedAt=unitcodesData.updatedAt;
        unitcodes.updatedUser=unitcodesData.updatedUser;
        unitcodes.versionFlag=unitcodesData.versionFlag;
        unitcodes.company =unitcodesData.company;
        unitcodes.companyId =unitcodesData.companyId;

        return unitcodes;
    }
}